import { render, staticRenderFns } from "./FaceDetection.vue?vue&type=template&id=315c9b7c&"
import script from "./FaceDetection.vue?vue&type=script&lang=js&"
export * from "./FaceDetection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports